import React from 'react';

export const AloneWrapper = (props) => (
  <div
    style={{
      minHeight: '100vh',
    }}
    className="flex justify-content-space-between align-items-center"
  >
    {props.children}
  </div>
);
